var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blank-room"},[_c('img',{attrs:{"src":_vm.image,"alt":"blank"}}),_c('p',[_vm._v("Please select a conversation to start messaging")])])
}
var staticRenderFns = []

export { render, staticRenderFns }